module.exports = __webpack_public_path__ + "img/pig.4073f8e4.svg";